import React from 'react'
import OpenSpaceSubForm from "./OpenSpaceSubForm";
import CompanySubForm from "./CompanySubForm";
import FloorSubForm from "./FloorSubForm";
import BuildingSubForm from "./BuildingSubForm";
import { availableEntityTypes } from "../utils";
import _ from "../../../baseApp/shared/utils/ObjectUtils";
import MeetingRoomSubForm from './MeetingRoomSubForm';

const EntityTypeSubForm = ({
    entityType,
    providerList,
    subFormData = {},
    viewMode,
    editMode,
    createMode,
    handleFieldChange,
    handleImageUploaded,
    handleWrongImageFormat
}) => {
    if(!_.isNilOrEmpty(subFormData)) {
        return entityTypeSubForm(entityType, providerList, subFormData, handleFieldChange, handleImageUploaded, handleWrongImageFormat, viewMode, editMode, createMode);
    } else {
        return null;
    }
};

function entityTypeSubForm(entityType, providerList, subFormData, handleFieldChange, handleImageUploaded, handleWrongImageFormat, viewMode, editMode, createMode) {
    switch(entityType){
        case availableEntityTypes.openSpace: {
            return <OpenSpaceSubForm
                {...subFormData}
                handleFieldChange={handleFieldChange}
                viewMode={viewMode}
                editMode={editMode}
                createMode={createMode}
            />;
        }
        case availableEntityTypes.company: {
            return <CompanySubForm
                {...subFormData}
                handleFieldChange={handleFieldChange}
                viewMode={viewMode}
                editMode={editMode}
                createMode={createMode}
            />;
        }
        case availableEntityTypes.floor:{
            let imageLabelStyle = {marginTop: "17px", position: "relative", display: 'inline-block', width:"225px"};
            return <FloorSubForm
                {...subFormData}
                style={imageLabelStyle}
                handleImageUploaded={handleImageUploaded}
                handleWrongImageFormat={handleWrongImageFormat}
                viewMode={viewMode}
                editMode={editMode}
                createMode={createMode}
            />;
        }
        case availableEntityTypes.meetingRoom:{
            return <MeetingRoomSubForm
                {...subFormData}
                providerList={providerList}
                handleFieldChange={handleFieldChange}
                viewMode={viewMode}
                editMode={editMode}
                createMode={createMode}
            />;
        }
        case availableEntityTypes.building:{
            return <BuildingSubForm
                {...subFormData}
                handleFieldChange={handleFieldChange}
                viewMode={viewMode}
                editMode={editMode}
                createMode={createMode}
            />;
        }
        default:
            return null;
    }
}

export default EntityTypeSubForm;